import { useReducer } from "react";

export type InsuranceContactFormFields =
  | "submitted"
  | "from"
  | "title"
  | "caseNumber"
  | "message"

export interface InsuranceContactFormState {
  submitted: boolean
  from: string,
  title: string,
  caseNumber?: number,
  message: string,
};

interface InsuranceContactFormAction {
  type: "update" | "clear",
  field: InsuranceContactFormFields
  payload?: any;
}

const reducer = (state: InsuranceContactFormState, action: InsuranceContactFormAction) => {
  switch (action.type) {
    case "update":
      return {
        ...state,
        [action.field]: action.payload,
      };
    case "clear":
      return {
        ...state,
        [action.field]: {},
      };
    default:
      return state;
  }
};

export const useInsuranceContactForm = () => {
  const [state, dispatch] = useReducer(reducer, {
    submitted: false,
    from: "",
    title: "",
    message: "",
  });

  return { state, dispatch };
};
